module.exports = __webpack_public_path__ + "index/img/icon_dijia.5f8ba1b2.svg";